// TERA (PlayD)
export const tera = {
	init() {
		this.btmSC();
	},
	topSC() { // 사용 X
		(function (win, name) {
			win['LogAnalyticsObject'] = name;
			win[name] =
				win[name] ||
				function () {
					(win[name].q = win[name].q || []).push(arguments);
				};
		})(window, '_LA');
	},
	btmSC() {
		// 공통태그 - 하단 태그
		try {
			var _nSA = (function (_g, _s, _p, _d, _i, _h) {
				if (_i.wgc != _g) {
					_i.wgc = _g;
					_i.wrd = new Date().getTime();
					var _sc = _d.createElement('script');
					_sc.src = _p + '//sas.techhub.co.kr/' + _s + 'gc=' + _g + '&rd=' + _i.wrd;
					var _sm = _d.getElementsByTagName('script')[0];
					_sm.parentNode.insertBefore(_sc, _sm);
				}
				return _i;
			})('TR10238206072', 'sa-w.js?', location.protocol, document, window._nSA || {}, location.hostname);
		} catch (error) {
			console.error('[TERA btmSC ERROE]', error);
		}
	},
	reset: {
		view() {
			window._LA.EC.RESET('VIEW');
		},
		prch() {
			window._LA.EC.RESET('PRCH');
		},
		cart() {
			window._LA.EC.RESET('CART');
		},
	},
	search(txt) {
		// 상품 검색
		try {
			window._LA.IS(txt);
		} catch (error) {
			console.error('[TERA search ERROE]', error);
		}
	},
	detail: {
		// 제품 상세
		view(id, name, price, cnt = 1, category = '') {
			try {
				tera.reset.view();
				window._LA.EC.VW();
				window._LA.EC.INIT('VIEW', String(id), name, Number(price), Number(cnt), category); // 제품ID, 제품명, 제품단가, 제품수량, 카테고리-옵션;
			} catch (error) {
				console.error('[TERA detailView ERROE]', error);
			}
		},
		cart(id = [], cnt = 1) {
			// 제품 상세 - 장바구니 담기 액션 버튼
			// ['제품ID'], 제품수량
			try {
				window._LA.EC.CI(id, Number(cnt)); // 제품ID, 제품명, 제품단가, 제품수량, 카테고리-옵션;
				// _LA.EC.CI(['제품ID'], 제품수량) // 장바구니 담기 버튼 액션 :: 마우스 버튼 다운이 있을때 상품 cnt 갯수만큼 담게 됩니다.
				// 	-> 제품이 여러 개인 경우 ['A001','A002'] , [1,2] 와 같이 배열로 증가처리 합니다.
			} catch (error) {
				console.error('[TERA detailCart ERROE]', error);
			}
		},
	},
	cart: {
		// 장바구니
		view(id, name, price, cnt = 1, category = '') {
			try {
				window._LA.EC.INIT('CART', String(id), name, Number(price), Number(cnt), category); // 제품ID, 제품명, 제품단가, 제품수량, 카테고리 :: 결재 상품 수만큼 로우추가
				// ex) window._LA.EC.INIT('VIEW', id1, name1, price, cnt, category)
				// ex) window._LA.EC.INIT('VIEW', id2, name2, price, cnt, category)
			} catch (error) {
				console.error('[TERA cartView ERROE]', error);
			}
		},
		delete(id = []) {
			try {
				window._LA.EC.CD(id); // ['제품ID', '제품ID'] :: 여러개 상품을 삭제할 때 배열로 처리 가능
			} catch (error) {
				console.error('[TERA cartDelete ERROE]', error);
			}
		},
		allDelete() {
			try {
				window._LA.EC.CR();
			} catch (error) {
				console.error('[TERA allDelete ERROE]', error);
			}
		},
	},
	purchase: {
		// 구매완료
		ggoods(id, name, price, cnt, category = '') {
			try {
				tera.reset.prch();
				window._LA.EC.INIT('PRCH', String(id), name, Number(price), Number(cnt), category); // 제품ID, 제품명, 제품단가, 제품수량, 카테고리 :: 결재 상품 수만큼 로우추가
				// ex) window._LA.EC.INIT('PRCH', id1, name1, price, cnt, category)
				// ex) window._LA.EC.INIT('PRCH', id2, name2, price, cnt, category)
			} catch (error) {
				console.error('[TERA purchaseGgoods ERROE]', error);
			}
		},
		total(totalPrice, paymentType) {
			try {
				window._LA.EC.PC(Number(totalPrice), paymentType); // 총결재액, 결제종류(0 : 기타, 1 : 신용카드, 2 : 계좌이체, 3 : 무통장, 4 : 간편결제, 5 : 휴대폰 결제)
			} catch (error) {
				console.error('[TERA purchaseTotal ERROE]', error);
			}
		},
	},
};
